<template>
    <div v-if="document && models && models.length">
        <b-row
            v-for="(model) in models"
            class="py-1 border-bottom"
        >
            <b-col class="py-1">{{ model[label_field] }}</b-col>
            <b-col class="text-right">
                <i v-if="isSelected(model[key_field])" class="fal fa-toggle-on text-success fa-2x permission-select" @click="togglePermission(model[key_field])"></i>
                <i v-if="!isSelected(model[key_field])" class="fal fa-toggle-off text-primary fa-2x permission-select" @click="togglePermission(model[key_field])"></i>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";

  export default {
    name: 'PermissionList',
    mixins: [ToastNotifications],
    props: {
      document: {
        default: function () {
          return null;
        }
      },
      models: {
        default: function () {
          return null;
        }
      },
      selected: {
        default: function () {
          return [];
        }
      },
      label_field: {
        default: function () {
          return null;
        }
      },
      key_field: {
        default: function () {
          return null;
        }
      },
    },
    data() {
      return {
        permitted: []
      };
    },
    watch: {

    },
    methods: {
      isSelected: function(key) {
        if(this.permitted.indexOf(key) !== -1) {
          return true;
        }
        return false;
      },
      togglePermission(key) {
        let index = this.permitted.indexOf(key);
        if(index !== -1) {
          this.permitted.splice(index, 1);
        } else {
          this.permitted.push(key);
        }
      }
    },
    created() {
        if(this.selected) {
          this.permitted = this.selected;
        }
    }
  }
</script>
<style>
    .permission-select {
        cursor: pointer;
        cursor: hand;
    }
</style>